import { render, staticRenderFns } from "./teaminform.vue?vue&type=template&id=f6e70b9a&scoped=true&"
import script from "./teaminform.vue?vue&type=script&lang=js&"
export * from "./teaminform.vue?vue&type=script&lang=js&"
import style0 from "./teaminform.vue?vue&type=style&index=0&id=f6e70b9a&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e70b9a",
  null
  
)

export default component.exports